// eslint-disable-next-line react/jsx-filename-extension
import React from 'react';
import '@4r/ant-theme-config/dist/index.css';
import {
  ENTERPRISE_CONTRACT_EVENT,
  I4EnterpriseContracts,
} from '@4r/mf-contracts';
import { init } from '@4r/module-common-error-handler';
import { notification } from 'antd';
import { getService } from '@4r/mf-app';
import AppContainer from './containers/AppContainer';
import { ApiException } from './api/api';
import RootContainer from './containers/RootContainer';

init(notification, ApiException);

const menu: I4EnterpriseContracts = {
  TimeAttendanceMicrofrontend: {
    priority: 0,
    route: '/time-attendance',
    channels: ['4Services'],
    enabledLDFlag: '4services-enable-clock-in',
    leftMenus: {},
    initComponent: RootContainer,
  },
};

getService('MessageBusService').emit(ENTERPRISE_CONTRACT_EVENT, menu);

export { AppContainer as reactElement };
